import PropTypes from 'prop-types';
import React from 'react';
import { getShortUuid } from 'src/utils/url';

const ScannedContainersList = ({
  containerUuids,
  namesByUuid,
  isLoading,
  ariaLabel,
  emptyLabel,
  loadingLabel,
  unavailableLabel,
}) => {
  if (!containerUuids.length) {
    return emptyLabel ? <p className='scanned-containers-list__empty'>{emptyLabel}</p> : null;
  }

  return (
    <ol className='scanned-containers-list' aria-label={ariaLabel}>
      {containerUuids.map((uuid, index) => {
        const name = namesByUuid[uuid];
        const statusLabel = isLoading ? loadingLabel : unavailableLabel;

        return (
          <li key={uuid} className='scanned-containers-list__item'>
            <span
              className='badge-circle badge-circle--muted scanned-containers-list__index'
              aria-hidden='true'
            >
              {index + 1}
            </span>
            <div className='scanned-containers-list__body'>
              <span
                className={`scanned-containers-list__name ${name ? '' : 'scanned-containers-list__name--muted'}`.trim()}
              >
                {name || statusLabel}
              </span>
              <span className='batch-split-uuid-badge scanned-containers-list__uuid'>
                {getShortUuid(uuid)}
              </span>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

ScannedContainersList.propTypes = {
  containerUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  namesByUuid: PropTypes.objectOf(PropTypes.string),
  isLoading: PropTypes.bool,
  ariaLabel: PropTypes.string,
  emptyLabel: PropTypes.string,
  loadingLabel: PropTypes.string,
  unavailableLabel: PropTypes.string,
};

ScannedContainersList.defaultProps = {
  namesByUuid: {},
  isLoading: false,
  ariaLabel: 'Containers',
  emptyLabel: '',
  loadingLabel: 'Loading material lot…',
  unavailableLabel: 'Material lot unavailable',
};

export default ScannedContainersList;
